import axios from "axios"

const initializeApp = () => {
    // Access tokens are now kept in Redux memory and renewed with the
    // httpOnly refresh-token cookie. Remove the token left behind by older
    // frontend versions before any authentication request is made.
    if (typeof window !== "undefined") {
        try {
            window.localStorage.removeItem("token")
        } catch {
            // localStorage can be unavailable in restricted browser contexts.
        }
    }

    
    // Setting base URL for all API request via axios
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL


    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code



    } else {
        // Prod build code



        // Removing console.log from prod
        console.log = () => {};


        // init analytics here
    }

}

export default initializeApp
